import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getAllowanceFormValues } from 'src/reducers/clients/allowances';
import selector from 'src/utils/Utils';

import { Plus, Delete } from 'jbc-front/components/icons';

const EditableRow = ({
  handleAddNewRow,
  index,
  selectedMotivationStep,
  row,
  handleInputChanged,
  handleRemoveRow,
  selectedMotivationState,
  errorRows,
  setErrorRows,
  disable
}) => {
  const { t } = useTranslation();
  const onAddNewRow = () => {
    handleAddNewRow(index);
    if (Array.isArray(errorRows)) {
      setErrorRows(prevRowIndex =>
        prevRowIndex.map(idx => {
          if (index < idx) {
            return idx + 1;
          }
          return idx;
        })
      );
    }
  };

  const onDeleteRow = () => {
    handleRemoveRow(index);
    if (Array.isArray(errorRows)) {
      const removeIndex = errorRows.indexOf(index);
      errorRows.splice(removeIndex, 1);
      const newErrorRow = [...errorRows];
      for (let i = removeIndex; i < errorRows.length; i += 1) {
        newErrorRow[i] = errorRows[i] - 1;
      }
      setErrorRows(newErrorRow);
    }
  };

  return (
    <div className={`${Array.isArray(errorRows) && errorRows.includes(index) ? 'row-error ' : ''} editable-table-row`}>
      <div className="editable-table-column"> {index + 1} </div>
      <div className="editable-table-column">
        <div className="d-flex align-items-center justify-content-between input-section gap-1">
          <div style={{ width: '100%' }}>
            <input
              disabled={index === 0}
              value={index === 0 ? 1 : row.fromMonth}
              type="text"
              maxLength={3}
              name="fromMonth"
              min={(index !== 0 && selectedMotivationStep[index - 1]?.toMonth) || 1}
              onChange={e => handleInputChanged(e, index)}
              placeholder={t('features.ClientMotivation.components.EditableRow.month_limit')}
              required
            />
          </div>
          <span>to</span>
          <div style={{ width: '100%' }}>
            <input
              onChange={e => handleInputChanged(e, index)}
              value={row.toMonth || ''}
              name="toMonth"
              min={(index !== 0 && selectedMotivationStep[index]?.fromMonth) || 1}
              maxLength={3}
              type="text"
              required
              placeholder={t('features.ClientMotivation.components.EditableRow.month_limit')}
            />
          </div>
        </div>
      </div>
      <div className="input-section editable-table-column">
        <input
          required
          onChange={e => handleInputChanged(e, index)}
          value={row.bonusAmount || ''}
          name="bonusAmount"
          type="number"
          placeholder="0"
          min={0}
        />
      </div>
      {selectedMotivationState === 'fulltime' && (
        <div className="editable-table-button-container editable-table-column">
          <div className="d-flex">
            <button disabled={disable} className="editable-table-button icon-green" onClick={onAddNewRow} type="button">
              <Plus size={16} />
            </button>
            <button disabled={index === 0} className="editable-table-button icon-red" onClick={onDeleteRow} type="button">
              <Delete size={20} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  selectedMotivationStep: selector(getAllowanceFormValues(state), 'motivationStep'),
  selectedMotivationState: selector(getAllowanceFormValues(state), 'motivationState')
});

export default connect(mapStateToProps)(EditableRow);
